// Zone4.js
import React from 'react';
import kailashImg from '../ZonetablePoster/Kailash.png'; 
import '../ZonetablePoster/allzones.css';

const videoLinks = [
  { title: "The PRUTL TIME-STORM (Hindi)", link: "https://youtu.be/TCplOOetWkw" },
  { title: "The PRUTL TIME-STORM (English)", link: "https://youtu.be/H4LM5TybwzA" },
  { title: "When Hearts Whisper Again (English)", link: "https://youtu.be/i2205elRN_Q" },
  { title: "When Hearts Whisper Again (Hindi)", link: "https://youtu.be/m0AWB93y0wA" },
  { title: "EMI-e-motion (Hindi)", link: "https://youtu.be/R5ed2r2v8pg" },
  { title: "EMI-e-motion (English)", link: "https://youtu.be/COtnOAIksEI" },
  { title: "The Last Bus to Kailash (Hindi)", link: "https://youtu.be/pnNX9GcyWqc" },
  { title: "The Last Bus to Kailash (English)", link: "https://youtu.be/tVR8uBi-xaY" },
  { title: "THE MIRROR OF ERIS (Hindi)", link: "https://youtu.be/jruynx0gFeU" },
  { title: "THE MIRROR OF ERIS (English)", link: "https://youtu.be/o4L07RZJj0k" }
];

const tableData = [
  {
    picture: kailashImg,
    title: "The Last Bus to Kailash",
    genre: "Emotional Drama • Spiritual Journey • Comedy of Realization Format"
  }
];

function Zone4() {
  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px' }}>
      <h1 className="zone-title">Zone 4</h1>

      <table className="zone-table">
        <thead>
          <tr>
            <th>Museo Series</th>
            <th>Title</th>
            <th>Genre</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, idx) => (
            <tr key={idx}>
              <td><img src={item.picture} alt={item.title} /></td>
              <td className="title">{item.title}</td>
              <td className="genre">{item.genre}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Videos Grid */}
      <div className="episodes-grid" style={{ marginTop: '40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {videoLinks.map((video, index) => (
          <div key={index} className="episode-card" style={{ backgroundColor: '#111', padding: '10px', borderRadius: '8px' }}>
            <div className="episode-thumbnail" style={{ height: '180px' }}>
              <iframe
                width="100%"
                height="100%"
                src={video.link.replace("youtu.be/", "www.youtube.com/embed/")}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderRadius: '6px' }}
              ></iframe>
            </div>
            <div className="episode-title" style={{ marginTop: '8px', color: 'white', textAlign: 'center' }}>
              {video.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


export default Zone4;
